import { useCallback, useState } from "react";
import { PostgresFields } from "./PostgresFields";
import { type PostgresWriteMode, toPostgresPayload } from "./postgresPayload";

export function usePostgresFields() {
  const [connectionString, setConnectionString] = useState("");
  const [writeMode, setWriteMode] = useState<PostgresWriteMode>("insert");
  const toPayload = useCallback(
    () => toPostgresPayload(connectionString, writeMode),
    [connectionString, writeMode],
  );

  const fields = (
    <PostgresFields
      connectionString={connectionString}
      setConnectionString={setConnectionString}
      writeMode={writeMode}
      setWriteMode={setWriteMode}
    />
  );

  return { fields, toPayload };
}
